import React from "react";
var __jsx = React.createElement;
import Table from './Table';
function TableAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(Table, {
    content: entry.tableContent,
    anchorLink: entry.anchorLink
  });
}
export default TableAdapter;